import { axios } from "@app/services";
import { IUserPasswordResetProps, IAuthData, IUserPasswordProps, ILoginResponse } from "./types";

export const getUser = async (): Promise<IAuthData> => {
    const response = await axios.get("auth/check");

    return response.data;
};

export interface ILoginProps {
    email: string;
    password: string;
    remember?: boolean;
}

export const login = async (props: ILoginProps): Promise<ILoginResponse> => {
    const response = await axios.post("auth/login", props);

    return { two_factor: Boolean(response.data?.two_factor) };
};

export const submitTwoFactorChallenge = async (payload: { code?: string; recovery_code?: string }): Promise<void> => {
    await axios.post("auth/two-factor-challenge", payload);
};

export const confirmPassword = async (password: string): Promise<void> => {
    await axios.post("auth/user/confirm-password", { password });
};

export const enableTwoFactor = async (): Promise<void> => {
    await axios.post("auth/user/two-factor-authentication");
};

export const getTwoFactorQrCode = async (): Promise<{ svg: string; url: string }> => {
    const response = await axios.get("auth/user/two-factor-qr-code");

    return response.data;
};

export const getTwoFactorSecretKey = async (): Promise<string> => {
    const response = await axios.get("auth/user/two-factor-secret-key");

    return response.data.secretKey;
};

export const confirmTwoFactor = async (code: string): Promise<void> => {
    await axios.post("auth/user/confirmed-two-factor-authentication", { code });
};

export const getTwoFactorRecoveryCodes = async (): Promise<string[]> => {
    const response = await axios.get("auth/user/two-factor-recovery-codes");

    return response.data;
};

export const logout = async () => {
    await axios.post("auth/logout");
};

export interface IRequestPasswordResetProps {
    email: string;
}

export const requestPasswordReset = async (props: IRequestPasswordResetProps) => {
    await axios.post("auth/forgot-password", props);
};

export const changeUserPassword = async (props: IUserPasswordProps): Promise<IUserPasswordProps> => {
    const response = await axios.post<IUserPasswordProps>("auth/change-password", props);

    return response.data;
};

export const updateUserPassword = async (props: IUserPasswordResetProps): Promise<IUserPasswordResetProps> => {
    const response = await axios.post<IUserPasswordResetProps>("auth/update-password", props);

    return response.data;
};

export const validateResetToken = async (token: string, email?: string | null) => {
    const response = await axios.post("auth/validate-reset-token", {
        token,
        ...(email ? { email } : {}),
    });

    return response.data;
};
